module.exports = __webpack_public_path__ + "img/amex.01ed7298.jpg";